/**
 * @file Manages site header events.
 */
((Drupal) => {
  class SiteWideHeader {
    constructor() {
      this.initialize();
    }

    closeOnScape(event) {
      if (event.key === 'Escape') {
        document.querySelectorAll('.menu_link_content.show').forEach(item => {
          item.parentElement.classList.remove('active');
          item.parentElement.querySelector('.menu-item__trigger').attributes['aria-expanded'].value = 'false';
          item.classList.remove('show');
        });

        // Move the focus to the trigger button
        document.querySelector('.menu-item__trigger').focus();
      }
    }

    toggleMenu(event) {
      const menuLinkContent = event.target.parentElement.querySelector('.menu_link_content');
      document.querySelectorAll('.menu_link_content.show').forEach(item => {
        if (item !== menuLinkContent) {
          item.parentElement.classList.remove('active');
          item.parentElement.querySelector('.menu-item__trigger').attributes['aria-expanded'].value = 'false';
          item.classList.remove('show');
        }
      });
      if (document.querySelector('.site-wide-header__search-toggle[aria-expanded="true"]')) {
        document.querySelector('.site-wide-header__search-toggle[aria-expanded="true"]').attributes['aria-expanded'].value = 'false';
      }
      if (document.querySelector('.site-wide-header__search-area')) {
        document.querySelector('.site-wide-header__search-area').classList.remove('show');
      }
      if (!menuLinkContent.classList.contains('show')) {
        event.target.attributes['aria-expanded'].value = 'true';
        event.target.parentElement.classList.add('active');
        menuLinkContent.classList.add('show');
        document.body.classList.add('menu-open');
        document.documentElement.classList.add('menu-open');
      } else {
        event.target.attributes['aria-expanded'].value = 'false';
        menuLinkContent.classList.remove('show');
        event.target.parentElement.classList.remove('active');
        document.body.classList.remove('menu-open');
        document.documentElement.classList.remove('menu-open');
      }
    }

    openMobileMenu(event) {
      const searchArea = document.querySelector('.site-wide-header__search-area');
      const searchAreaBtn = document.querySelector('.site-wide-header__search-toggle');
      const mobileMenu = document.querySelector('.site-wide-header__main-menu-area');
      if (!mobileMenu.classList.contains('show')) {
        searchArea.classList.remove('show');
        searchAreaBtn.attributes['aria-expanded'].value = 'false';
      }
      mobileMenu.classList.toggle('show');
      document.body.classList.toggle('menu-open');
      document.documentElement.classList.toggle('menu-open');
      event.target.attributes['aria-expanded'].value = mobileMenu.classList.contains('show');
    }

    initialize() {
      const mainMenuTriggers = document.querySelectorAll('.menu-item__trigger');
      const mobileMenuTrigger = document.querySelector('.site-wide-header__menu-toggle');
      if (mobileMenuTrigger && !mobileMenuTrigger.classList.contains('initialized')) {
        mobileMenuTrigger.addEventListener('click', this.openMobileMenu.bind(this));
        mobileMenuTrigger.classList.add('initialized');
      }
      if (mainMenuTriggers.length) {
        this.initialized = true;
        mainMenuTriggers.forEach(trigger => {
          if (trigger.classList.contains('initialized')) {
            return;
          }
          trigger.addEventListener('click', this.toggleMenu.bind(this));
          trigger.classList.add('initialized');
        });
      }
    }
  }

  Drupal.behaviors.siteWideHeader = {
    attach: function(context, settings) {
      if (document !== context) {
        return;
      }

      new SiteWideHeader();
    }
  }
})(Drupal);